import React, { useState, useEffect } from "react";
import "./MarketOddBtn.scss";
import { ReactComponent as LockIcon} from "../../assets/images/sports/Lock.svg";
import { setTextColor } from "../../store/auth/authActions";

type PropType = {
  mainValue?: any;
  mainValueClass?: "price" | "runs";
  subValue?: any;
  subValueClass?: "size" | "odds";
  disable?: boolean;
  oddType: "back-odd" | "lay-odd" | "odds-yes-cell" | "odds-no-cell";
  valueType?: "matchOdds" | "bookmakerOdds" | "fancyMarketOdds" | "binaryOdds";
  onClick?: () => void;
  oddsSet?: number[];
  showSubValueinKformat?: boolean;
};

const MarketOddBtn: React.FC<PropType> = (props) => {
  const {
    mainValue,
    mainValueClass,
    subValue,
    subValueClass,
    disable,
    oddType,
    valueType,
    onClick,
    oddsSet,
    showSubValueinKformat,
  } = props;
  const [currentValue, setCurrentValue] = useState<number>(null);
  const [classes, setClasses] = useState<string>("exch-odd-button");
  const [timer, setTimer] = useState(null);
  const [currentOdds, setCurrentOdds] = useState<number[]>([]);
  const [volume, setVolume] = useState<number>();
  const subValprecision: number = valueType === "matchOdds" ? 2 : 0;

  useEffect(() => {
    if (subValue) {
      if (valueType === "matchOdds") setVolume(subValue * 100);
      else setVolume(subValue);
    }
  }, [subValue, valueType]);

  const oddValueChanged = () => {
    clearTimeout(timer);
    const chVal = mainValue;
    if (chVal) {
      const cVal = currentValue;
      setCurrentValue(chVal);
      let showAnimation = true;
      if (oddsSet && oddsSet.length > 0) {
        showAnimation = !currentOdds.includes(chVal);
        setCurrentOdds(oddsSet);
      }
      if (showAnimation) {
        if (cVal && chVal !== cVal) {
          if (!classes.includes("odd-change"))
            setClasses(classes + " odd-change");
          setTimer(
            setTimeout(
              () => setClasses(" exch-odd-button "),
              5000
            )
          );
        }
      }
    }
  };

  useEffect(() => oddValueChanged(), [mainValue, subValue]);

  return (
    <div className="exch-odd-view">
      {mainValue && Number(mainValue) > 0 ? (
        <div
          className={
            disable ? `${oddType} ${setTextColor(getComputedStyle(document.body).getPropertyValue('--odd-button-color'))} disabled ` + classes : `${oddType} ${setTextColor(getComputedStyle(document.body).getPropertyValue('--odd-button-color'))} ` + classes
          }
          onClick={() => onClick()}
        >
          <div className="exch-odd-button-content">
            <div className={mainValueClass ? mainValueClass : "price"}>
              {Number.isNaN(Number(mainValue)) ? (
                <br></br>
              ) : (
                // Number(mainValue).toFixed(mainValprecision)
                mainValue
              )}
            </div>

            <div className={subValueClass ? subValueClass : "size"}>
              {volume
                ? showSubValueinKformat && Number(volume > 999)
                  ? Number(volume / 1000).toFixed(subValprecision) + "K"
                  : valueType === "bookmakerOdds"
                  ? Number(volume).toFixed(subValprecision) + "K"
                  : Number(volume).toFixed(subValprecision)
                : "0.00K"}
            </div>
          </div>
        </div>
      ) : (
        <div className={`${oddType} disabled ` + classes}>
          <LockIcon
            className="lock-icon"
          />
        </div>
      )}
    </div>
  );
};

export default MarketOddBtn;
